import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["preserveAspectRatio", "viewBox"];
import React from 'react';

var LockOutline = function LockOutline(_ref) {
  var _ref$preserveAspectRa = _ref.preserveAspectRatio,
      preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'xMidYMid meet' : _ref$preserveAspectRa,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({}, unhandledProps, {
    preserveAspectRatio: preserveAspectRatio,
    viewBox: viewBox
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.06592 22.6665H16.9341C18.5613 22.6665 19.3591 21.8582 19.3591 20.0945V12.6304C19.3591 11.0662 18.7292 10.2578 17.4485 10.0898V7.6438C17.4485 3.65454 14.7925 1.7334 12 1.7334C9.20752 1.7334 6.55151 3.65454 6.55151 7.6438V10.0898C5.27075 10.2578 4.64087 11.0662 4.64087 12.6304V20.0945C4.64087 21.8582 5.43872 22.6665 7.06592 22.6665ZM8.56714 7.45483C8.56714 5.00879 10.1208 3.66504 12 3.66504C13.8687 3.66504 15.4329 5.00879 15.4329 7.45483V10.0583H8.56714V7.45483ZM7.40186 20.7664C6.93994 20.7664 6.70898 20.5459 6.70898 20V12.7249C6.70898 12.1685 6.93994 11.969 7.40186 11.969H16.6086C17.0706 11.969 17.291 12.1685 17.291 12.7249V20C17.291 20.5459 17.0706 20.7664 16.6086 20.7664H7.40186Z"
  })));
};

LockOutline.displayName = 'LockOutline';
export default LockOutline;